// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"195":"97197713","272":"0116fa76","594":"9d6ce5c0","786":"4330d055","900":"c31343ef"}[chunkId] + ".css";
};